import React from 'react';

import S from 'app/features/registrationPromo/components/Benefits.styled';
import Benefit from 'app/features/registrationPromo/components/Benefit';

const Benefits = () => (
  <S.Benefits>
    {[
      'registration_promo_benefit_1',
      'registration_promo_benefit_2',
      'registration_promo_benefit_3',
    ].map(titleId => (
      <Benefit key={`${titleId}`} titleId={titleId} />
    ))}
  </S.Benefits>
);

export default Benefits;
